import { drupalComponent } from '@nech/src/helpers/drupal-component';

/**
 * SUA1616-433 - Safari 13 issue, date input not implemented.
 * We use a default placeholder to prefill the dates fields.
 * This placeholder will only appear when a placeholder is not contributed in drupal.
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('input[type="date"]').forEach(input => {
    if (!input.hasAttribute('placeholder')) {
      input.setAttribute('placeholder', 'jj/mm/aaaa');
    }
  });
});

(function (Drupal, $) {
  drupalComponent('nech_webform_steps', {
    selector: '[class^="webform-submission-"]',

    shared: {
      floatingLabel: function ($el: JQuery<HTMLElement>) {
        $el.each(function () {
          const $input = $(this).find('input, textarea, select');
          const $label = $(this).find('label');

          if ($input.length && $label.length) {
            $input.on('input', function () {
              if ($input.val() !== '') {
                $label.addClass('nech--webform-input-has-value');
              } else {
                $label.removeClass('nech--webform-input-has-value');
              }
            });
          }
        });
      },

      resetFloatingLabels: function ($el: JQuery<HTMLElement>) {
        $el.each(function () {
          const $input = $(this).find('input, textarea, select');
          const $label = $(this).find('label');

          if ($input.length && $label.length) {
            if ($input.val() !== '') {
              $label.addClass('nech--webform-input-has-value');
            } else {
              $label.removeClass('nech--webform-input-has-value');
            }
          }
        });
      },
    },

    attach(context) {
      const $el = $(this.selector, context);
      const $labels = $el.find('label');
      const $input = $(this).find('input, textarea, select');

      //add * for required labels
      $labels.each(function () {
        if ($(this).hasClass('form-required')) {
          $(this).append(' *');
        }
      });

      //add * for required fieldset legends (for radios/checkboxes)
      const $legends = $el.find('legend');
      $legends.each(function () {
        const $legendSpan = $(this).find('span.fieldset-legend');
        if ($legendSpan.length && $legendSpan.hasClass('form-required')) {
          if (!$legendSpan.text().includes('*')) {
            $legendSpan.append(' *');
          }
        }
      });

      //add * to placeholer if not label
      $input.each(function () {
        if ($(this).length && !$(this).siblings('label').length && $(this).attr('required')) {
          const currentPlaceholder = $(this).attr('placeholder');
          if (currentPlaceholder) {
            $(this).attr('placeholder', currentPlaceholder + ' *');
          }
        }
      });
    },

    instance(context) {
      function toggleUploadVisibility() {
        const $wrapper = $('.js-form-type-webform-document-file');
        const uploadedCount = $wrapper.find('.file').length;

        const description = $wrapper.find('.webform-element-description').text();
        let maxFiles = Infinity;

        if (!description.includes('illimité') && !description.includes('unlimited')) {
          const match = description.match(/(\d+)\s*fichier/);
          if (match && match[1]) {
            maxFiles = parseInt(match[1], 10);
          } else {
            const isMultiple = $wrapper.find('input[type="file"][multiple]').length > 0;
            maxFiles = isMultiple ? Infinity : 1;
          }
        }

        const $uploadBlock = $wrapper.children('.upload-label-wrapper').first();

        if (uploadedCount >= maxFiles) {
          $uploadBlock.css('display', 'none');
        } else {
          $uploadBlock.css('display', 'flex');
        }
      }

      toggleUploadVisibility();

      $('.js-form-type-webform-document-file label').each(function () {
        $(this).data('wrapped', false);
      });

      const $el = $(this.selector, context);
      const self = this;
      const isMobile = window.innerWidth <= 640;

      //const buttons
      const $nextButton = $('.webform-button--next');
      const $prevButton = $('.webform-button--previous');
      const $submitButton = $('.webform-button--submit');
      const $confirmationBackButton = $('.webform-confirmation__back a');

      const prevButtonIcon =
        '<span class="ph ph-arrow-left bg-neutral-50 rounded-400 p-5 border border-solid border-primary-700 text-primary-700 cursor-pointer hover:bg-primary-700 hover:text-neutral-50 transition-all duration-200" aria-hidden="true"></span>';

      const deleteButtonIcon = '<span class="ph ph-trash text-base ms-3 flex items-center"></span>';

      //const inputs
      const mainInput = $(
        '.js-form-item:not(.form-item-birthday):not(.form-tel):has(input:not([type="radio"]), textarea)',
      );
      const $uploadFileLabel = $('.js-form-type-webform-document-file label');
      const upoadFileInputContent =
        '<div class="flex flex-col gap-3 justify-center"><span class="ph ph-file-arrow-up text-2xl text-primary-700" aria-hidden="true"></span></div><p class="text-neutral-600 text-base font-normal"></p>';
      const $textarea = $('.js-form-type-textarea');

      const $genderSelect = $('.form-item-sexe-select select');

      //required inputs
      const requiredInputs = $(
        'input[required="required"], textarea[required="required"], select[required="required"]',
      );

      let classStepButtonLabel = ' ';
      let classStepButtonIcon = ' ';

      if (requiredInputs.length) {
        classStepButtonLabel = ' bg-neutral-200 text-neutral-300 ';
        classStepButtonIcon = ' bg-neutral-100 text-neutral-300 ';
      } else {
        classStepButtonLabel =
          ' bg-primary-700 text-neutral-50 cursor-pointer hover:bg-primary-700 ';
        classStepButtonIcon = ' text-neutral-50 bg-primary-600 cursor-pointer ';
      }

      let isAvailableButton = false;

      $(function () {
        function updateMargin() {
          $('.js-form-type-select').each(function () {
            if ($(this).find('.form-item--error-message').filter(':visible').length > 0) {
              $(this).css('margin-bottom', '2rem');
            } else {
              $(this).css('margin-bottom', '1rem');
            }
          });
        }

        updateMargin();

        $(document).on('input change', '.js-form-type-select select', function () {
          updateMargin();
        });

        const observer = new MutationObserver(() => {
          updateMargin();
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      });

      requiredInputs.each(function () {
        $(this).on('input', function () {
          const allFilled = requiredInputs.toArray().every(input => $(input).val() !== '');

          // Mettre à jour les classes de bouton de soumission
          if (allFilled) {
            isAvailableButton = true;
            customStepLabel
              .removeClass('bg-neutral-200 text-neutral-300')
              .addClass('bg-primary-700 text-neutral-50 cursor-pointer hover:bg-primary-700');
            customStepLabel
              .find('span')
              .removeClass('bg-neutral-100 text-neutral-300')
              .addClass('bg-primary-600 text-neutral-50');

            customSubmitButton
              .removeClass('bg-neutral-200 text-neutral-300')
              .addClass('bg-primary-700 text-neutral-50 cursor-pointer hover:bg-primary-700');
            customSubmitButton
              .find('span')
              .removeClass('bg-neutral-100 text-neutral-300')
              .addClass('bg-primary-600 text-neutral-50');
          } else {
            isAvailableButton = false;
            customStepLabel
              .removeClass('bg-primary-700 text-neutral-50 cursor-pointer hover:bg-primary-700')
              .addClass('bg-neutral-200 text-neutral-300');
            customStepLabel
              .find('span')
              .removeClass('bg-primary-600 text-neutral-50')
              .addClass('bg-neutral-100 text-neutral-300');

            customSubmitButton
              .removeClass('bg-primary-700 text-neutral-50 cursor-pointer hover:bg-primary-700')
              .addClass('bg-neutral-200 text-neutral-300');
            customSubmitButton
              .find('span')
              .removeClass('bg-primary-600 text-neutral-50')
              .addClass('bg-neutral-100 text-neutral-300');
          }
        });
      });
      $('.form-date').on('input', function () {
        const value = $(this).val();
        const labelElement = $(this).prev('label');
        if ($(this).val() !== '') {
          $(labelElement).addClass('nech--webform-input-has-value');
        } else {
          $(labelElement).removeClass('nech--webform-input-has-value');
        }
        if (typeof value === 'string' && value.length >= 4) {
          const parts = value.split('-');
          if (parts.length === 3) {
            if (parts[0]) {
              parts[0] = parts[0].substring(0, 4);
            }
            $(this).val(parts.join('-'));
          }
        }
      });

      $(function () {
        function updateNextButtonState() {
          const allFilled = requiredInputs.toArray().every(input => $(input).val() !== '');

          if (allFilled) {
            isAvailableButton = true;
            customStepLabel
              .removeClass('bg-neutral-200 text-neutral-300')
              .addClass('bg-primary-700 text-neutral-50 cursor-pointer hover:bg-primary-700');
            customStepLabel
              .find('span')
              .removeClass('bg-neutral-100 text-neutral-300')
              .addClass('bg-primary-600 text-neutral-50');
          } else {
            isAvailableButton = false;
            customStepLabel
              .removeClass('bg-primary-700 text-neutral-50 cursor-pointer hover:bg-primary-700')
              .addClass('bg-neutral-200 text-neutral-300');
            customStepLabel
              .find('span')
              .removeClass('bg-primary-600 text-neutral-50')
              .addClass('bg-neutral-100 text-neutral-300');
          }
        }

        updateNextButtonState();

        requiredInputs.each(function () {
          $(this).on('input', function () {
            updateNextButtonState();
          });
        });
      });

      //change label by button element html
      $(function () {
        if ($uploadFileLabel.length) {
          const $uploadFileButton = $('<button type="button">')
            .addClass(
              'focus-primary-700-offset text-primary-700 font-normal border border-primary-700 rounded-400 py-3 px-5 inline-flex items-center cursor-pointer',
            )
            .css({
              'font-family': 'Montserrat',
              'font-size': '12px',
            })
            .html(Drupal.t('Sélectionner depuis votre appareil'));

          $uploadFileLabel.hide();

          $uploadFileLabel.after($uploadFileButton);

          $uploadFileButton.on('click', function () {
            const $fileInput = $uploadFileLabel.closest('.js-form-type-webform-document-file').find('input[type="file"]');
            ($fileInput[0] as HTMLInputElement | undefined)?.click();
          });
        }
      });

      const nextButtonIcon = `<span class="ph ph-arrow-right text-base absolute right-0 rounded-400 p-3 me-3 ${classStepButtonIcon} " aria-hidden="true"></span>`;
      const sumbmitButtonIcon = `<span class="ph ph-check text-base absolute right-0 rounded-400 p-3 me-3 ${classStepButtonIcon} " aria-hidden="true"></span>`;

      if ($textarea.find('textarea').html() !== '') {
        $textarea.find('label').addClass('nech--webform-textarea-has-value');
      }

      if (isMobile) {
        $textarea.find('textarea').attr('cols', 40);
      }

      //BUTTONS
      //next button
      $nextButton.hide();

      const customStepLabel = $('<button type="button">')
        .addClass(
          'nech--webforms-custom-js-buttons py-4 rounded-400 text-base font-normal relative flex items-center transition-all duration-200 focus-neutral-950-offset' +
            classStepButtonLabel,
        )
        .html(Drupal.t('Etape suivante') + nextButtonIcon);

      $nextButton.after(customStepLabel);

      customStepLabel.on('click', function () {
        if (isAvailableButton) {
          $nextButton.trigger('click');
        }
      });

      //checkbox container
      $('.js-form-type-checkbox').each(function () {
        const checkboxLabel = $(this).find('label');
        const checkboxDesc = $(this).find('.description');

        const checkboxWrapper = $('<div>').addClass('flex flex-col');
        checkboxLabel.add(checkboxDesc.css('margin-left', '16px')).wrapAll(checkboxWrapper);
      });

      //prev button
      $prevButton.hide();
      $confirmationBackButton.hide();
      const customPrevLabel = $(
        '<button type="button" class="flex mx-5 my-5 justify-center focus-neutral-950-offset">',
      ).html(prevButtonIcon);

      $prevButton.after(customPrevLabel);

      customPrevLabel.on('click', function () {
        $prevButton.trigger('click');
        $confirmationBackButton.trigger('click');
      });

      //submit button
      $submitButton.hide();

      const customSubmitButton = $('<button type="submit">')
        .addClass(
          'nech--webforms-custom-js-buttons py-4 rounded-400 text-base font-normal relative flex items-center transition-all duration-200 focus-neutral-950-offset' +
            classStepButtonLabel,
        )
        .html(Drupal.t('Valider') + sumbmitButtonIcon);
      $submitButton.after(customSubmitButton);

      customSubmitButton.on('click', function () {
        if (isAvailableButton) {
          $submitButton.trigger('click');
        }
      });

      //inputs

      $uploadFileLabel.each(function () {
        const $label = $(this);

        if ($label.data('wrapped')) return;
        $label.data('wrapped', true);

        if (!$label.parent().hasClass('upload-label-wrapper')) {
          const wrapperDiv = $(
            '<div class="upload-label-wrapper flex flex-col items-center gap-3 rounded-300 w-full px-5 py-6"></div>'
          );

          $label.wrap(wrapperDiv);
          $label.before(upoadFileInputContent);
        }
      });

      $uploadFileLabel.text(Drupal.t('Sélectionner depuis votre appareil'));

      $genderSelect.find('option').each(function () {
        if ($(this).val() === '') {
          $(this).text('Sexe');
        }
      });

      //floating label
      self.shared.floatingLabel(mainInput);
      $(function () {
        self.shared.resetFloatingLabels(mainInput);
      });

      function enhanceUploadUI() {
        const $labels = $('.js-form-type-webform-document-file > label');

        $labels.each(function () {
          const $label = $(this);

          if ($label.data('enhanced')) return;
          $label.data('enhanced', true);

          if (!$label.parent().hasClass('upload-label-wrapper')) {
            const wrapper = $('<div class="upload-label-wrapper flex flex-col items-center gap-3 rounded-300 w-full px-5 py-6"></div>');

            $label.wrap(wrapper);

            $label.before(`
        <div class="flex flex-col gap-3 justify-center">
          <span class="ph ph-file-arrow-up text-2xl text-primary-700"></span>
        </div>
        <p class="text-neutral-600 text-base font-normal"></p>
      `);
          }

          if (!$label.next('button').length) {

            const $btn = $(`
                <button type="button" class="custom-upload-btn text-primary-700 border border-primary-700 rounded-400 py-3 px-5 cursor-pointer">
                    Sélectionner depuis votre appareil
                </button>
            `);

            $label.hide();
            $label.after($btn);

            $btn.on('click', () => {
              const $fileInput = $label.closest('.js-form-type-webform-document-file').find('input[type="file"]');
              ($fileInput[0] as HTMLInputElement | undefined)?.click();
            });
          }
        });
      }

      function onFileUpload() {
        $('.js-webform-document-file .file a').each(function () {
          const $link = $(this);

          if (!$link.length || !$link[0]) return;

          const lastNode = $link[0].childNodes[$link[0].childNodes.length - 1];

          if (!lastNode || lastNode.nodeType !== Node.TEXT_NODE) return;

          const fileName = lastNode.textContent?.trim();

          if (!fileName) return;

          $link.html(`<span class="ph ph-file me-3"></span>${fileName}`);
        });
      }

      //stepper
      const stepperContainer = $('.webform-progress-tracker');

      if (stepperContainer.length) {
        const elFocusable = $('form')
          .find('select, input, textarea, button, a')
          .filter(':not([aria-hidden="true"]):not(.hidden):visible');

        stepperContainer.find('li').each(function (idx) {
          if ($(this).hasClass('progress-step') && $(this).hasClass('is-complete')) {
            $(this).find('.progress-marker').attr('data-text', '✓');
          }
          if (idx === stepperContainer.find('li').length - 1 && $(this).hasClass('is-active')) {
            stepperContainer.addClass('hidden');
          }
        });

        elFocusable.first().trigger('focus');
      }

      $(function () {
        function checkAndApplyErrorStyle() {
          requiredInputs.on('input', function () {
            let requiredInputValue = $(this).val();

            if (typeof requiredInputValue == 'string' && !requiredInputValue?.trim()) {
              $(this).addClass('input-error-focus');
            } else {
              $(this).removeClass('input-error-focus');
            }
          });
        }

        checkAndApplyErrorStyle();

        const observer = new MutationObserver(() => {
          checkAndApplyErrorStyle();
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      });

      (function ($) {
        $(function () {
          const $flagContainer = $('.js-form-type-tel');

          // Fonction pour vérifier la présence de l'erreur et mettre à jour la position
          function updateErrorStyle() {
            $flagContainer.find('input').each(function () {
              const errorSelector = $(this).next('.error.form-item--error-message');

              const isErrorVisible =
                errorSelector.length && errorSelector.css('display') !== 'none'; // Vérification de la visibilité de l'erreur

              if (isErrorVisible) {
                $flagContainer.find('.iti__flag-container').css('bottom', '16px');
              } else {
                $flagContainer.find('.iti__flag-container').css('bottom', '');
              }
            });
          }

          const observer = new MutationObserver(() => {
            updateErrorStyle();
          });

          observer.observe(document.body, {
            childList: true,
            subtree: true,
          });

          $flagContainer.find('input').on('input', function () {
            updateErrorStyle();
          });

          updateErrorStyle();
        });
      })(jQuery);

      // Sequential multi-file upload:
      // Drupal's auto-upload only sends one file at a time. We capture the full
      // FileList on change (capture phase, before Drupal's handler), then after
      // each AJAX response we inject the next pending file and re-trigger upload.
      let pendingFiles: File[] = [];
      let previousFileCount = document.querySelectorAll('.js-webform-document-file .file').length;

      document.addEventListener('change', function (e) {
        const target = e.target as HTMLInputElement;
        if (target.type !== 'file' || !target.closest('.js-webform-document-file')) return;
        if (!target.files || target.files.length <= 1) return;
        pendingFiles = Array.from(target.files).slice(1);
        previousFileCount = document.querySelectorAll('.js-webform-document-file .file').length;
      }, true);

      const observer = new MutationObserver(() => {
        observer.disconnect();

        setTimeout(() => {
          enhanceUploadUI();
          toggleUploadVisibility();
          onFileUpload();

          const currentFileCount = document.querySelectorAll('.js-webform-document-file .file').length;
          if (pendingFiles.length > 0 && currentFileCount > previousFileCount) {
            previousFileCount = currentFileCount;
            const nextFile = pendingFiles.shift()!;
            const fileInput = document.querySelector('.js-webform-document-file input[type="file"]') as HTMLInputElement | null;
            if (fileInput) {
              const dt = new DataTransfer();
              dt.items.add(nextFile);
              fileInput.files = dt.files;
              fileInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }, 0);

        setTimeout(() => {
          observer.observe(document, { subtree: true, childList: true });
        }, 0);
      });

      observer.observe(document, { subtree: true, childList: true });
    },
  });
})(Drupal, jQuery);
